import { i18n } from '@/locales';
import { isMobile } from '@/plugins/vuetify';
const desktopLc = 'views.worker_management.';
const mobileLc = 'views.worker.common.';
const workerTypeCode = [
    'NORMAL_WORKER',
    'BLACK_WORKER_5KM',
    'BLACK_WORKER_10KM',
];
const result = {};
workerTypeCode.forEach((code, index) => {
    result[code] = {
        text: i18n.t(`${desktopLc}worker_type_code_text[${index}]`),
        value: code,
    };
});
if (isMobile) {
    const key = 'PRIORITY_ALLOCATE_WORKER';
    result[key] = {
        value: key,
        text: `${mobileLc}worker_type_code_text[3]`,
    };
}
export default result;
